import { Data } from "@transformd-ltd/sdk";

let data;

export function getDataHelper() {
  return data;
}

export function initializeDataHelper() {
  data = new Data();
}
